/*
 * @Copyright 2020. Institute for Future Intelligence, Inc.
 *
 * @author Charles Xie, charles@intofuture.org
 */

import $ from "jquery";
// @ts-ignore
window.jQuery = $;
import "jquery-ui-bundle/jquery-ui.min.css";
import "jquery-ui-bundle/jquery-ui";
import "@fortawesome/fontawesome-free/css/all.css";
import {create, all} from "mathjs";
import html2canvas from "html2canvas";
import UndoManager from "undo-manager";
import queryString from "query-string";
// @ts-ignore
import clickSound from "./sound/stapler.mp3";

import * as Constants from "./Constants";
import {Sound} from "./Sound";
import {User} from "./User";
import {State} from "./State";
import {StateIO} from "./StateIO";
import {Examples} from "./Examples";
import {PngSaver} from "./tools/PngSaver";

import {Util} from "./Util";
import {Flowchart} from "./blocks/Flowchart";
import {BlockElementsPanel} from "./blocks/ui/BlockElementsPanel";
import {createContextMenusForBlocks} from "./BlockContextMenusMaker";
import {Firebase} from "./Firebase";
import {Email} from "./Email";

declare global {

  interface CanvasRenderingContext2D {
    drawTooltip(x, y, h, r, margin, text, centered);

    drawRoundedRect(x, y, w, h, r);

    fillRoundedRect(x, y, w, h, r);

    drawHalfRoundedRect(x, y, w, h, r, side);

    fillHalfRoundedRect(x, y, w, h, r, side);

    drawLine(x1, y1, x2, y2);

    drawRect(x, y, w, h);

    fillRect(x, y, w, h);

    drawCircle(x, y, r);

    fillCircle(x, y, r);

  }

  interface Array<T> {
    insertAt(index, item);

    removeItem(item);

    fill(value);
  }

  interface String {
    removeAllSpaces();

    replaceAll(s, t);

    startsWith(s);

    endsWith(s);

    replaceFromTo(start, end, replacement);
  }

  interface Math {
    hypot(x, y);

    sinh(x);

    cosh(x);

    sign(x);

    toRadian(x);

    toDegree(x);
  }
}

export const flowchart = new Flowchart();
export const user = new User("First", null, "Last");
export const contextMenus: any = {};
export const sound = new Sound();
export const math = create(all, {});
export const undoManager = new UndoManager();
export const examples = new Examples();
export const query = queryString.parse(location.search);
export const database = new Firebase();
export const emailClient = new Email();

export function closeAllContextMenus() {
  Object.keys(contextMenus).forEach(key => {
    let menu = document.getElementById(contextMenus[key].id) as HTMLMenuElement;
    menu.classList.remove("show-menu");
  });
}

export function getInstanceString(s: string): string {
  if (query.instanceid) s += ":" + query.instanceid;
  return s;
}

export function isNumber(x: any) {
  return !isNaN(parseFloat(x)) && isFinite(x);
}

function showUnderConstructionMessage() {
  let d = $("#modal-dialog");
  d.html("<div style='font-size: 90%;'>Under construction...</div>").dialog({
    resizable: false,
    modal: true,
    title: "Sorry",
    height: 150,
    width: 200,
    buttons: {
      'OK': () => d.dialog('close')
    }
  });
}

let social = `<span style="font-size: 2em; vertical-align: middle; cursor: pointer;" title="Facebook"><i class="fab fa-facebook-square"></i></span>
              <span style="font-size: 2em; vertical-align: middle; cursor: pointer;" title="Twitter"><i class="fab fa-twitter"></i></span>
              <span style="font-size: 2em; vertical-align: middle; cursor: pointer;" title="YouTube"><i class="fab fa-youtube"></i></span>`;

window.onload = function () {

  setupHeader();
  setupFooter();

  document.getElementById("main-page-previous-example-button").onclick = () => examples.loadPrevious();
  document.getElementById("main-page-next-example-button").onclick = () => examples.loadNext();

  createContextMenusForBlocks();

  let elementsPanel = new BlockElementsPanel();
  elementsPanel.render("block-elements-panel");

  if (query.tab === "flow") {
    document.getElementById("tabs").style.display = "none";
    let blockElementsPanel = document.getElementById("block-elements-panel");
    blockElementsPanel.style.top = "5px";
    blockElementsPanel.style.bottom = "5px";
  }

  setTimeout(() => { // call this to refresh after inserting canvases
    resize();
    draw();
  }, 1000);

  sound.setSource(clickSound);
};

export function loadInitialState() {
  if (query.example !== undefined) {
    examples.loadByTitle(query.example.toString());
  } else if (query.userid && query.filename) {
    database.openFile(query.userid.toString(), query.filename.toString());
  } else {
    // read locally stored properties
    StateIO.restoreBlockView(localStorage.getItem(getInstanceString("Block View State")));
    StateIO.restoreBlocks(localStorage.getItem(getInstanceString("Block States")));
    StateIO.restoreFunctionDeclarations();
    StateIO.restoreGlobalVariables();
    StateIO.restoreConnectors(localStorage.getItem(getInstanceString("Connector States"))); // connectors must be restored after loading HATs
    StateIO.finishLoading();
    flowchart.updateResultsExcludingAllWorkerBlocks();
    // flowchart.reset(); // FIXME: why did I call this?
  }
}

function setupFooter() {
  document.title = Constants.Software.name;
  let footer = document.getElementById('footer');
  footer.innerHTML = social + "<div class='horizontal-divider'></div>" + Constants.Software.name + " Version " + Constants.Software.version;
  footer.innerHTML += ", created by <a target='_blank' rel='noopener noreferrer' href='https://charxie.github.io' style='text-decoration: none;'>Dr. Charles Xie</a>, ";
  footer.innerHTML += " <a target='_blank' rel='noopener noreferrer' href='https://intofuture.org' style='text-decoration: none;'>Institute for Future Intelligence</a>, ";
  footer.innerHTML += "&copy;" + new Date().getFullYear();
  if (query.footer === "no") {
    footer.style.display = "none";
  }
}

function setupTitleLabel() {
  const titleLabel = document.getElementById("main-page-cloud-file-title-label");
  titleLabel.onclick = () => {
    let url = document.location.href;
    let title = titleLabel.innerHTML;
    if (title && title.trim() !== '' && title.indexOf(" (from ") === -1) { // the user is the owner
      let hasQuery = url.indexOf("?") > 0;
      if (hasQuery) {
        // replace userid if it exists
        let index = url.indexOf("userid=");
        if (index > 0) {
          let s = url.substring(index + 7);
          let nextIndex = s.indexOf("&");
          if (nextIndex >= 0) {
            s = s.substr(0, nextIndex);
          }
          url = url.replace(s, encodeURIComponent(user.email));
        } else {
          url += "&userid=" + encodeURIComponent(user.email);
        }
        // replace filename if it exists
        index = url.indexOf("filename=");
        if (index > 0) {
          let s = url.substring(index + 9);
          let nextIndex = s.indexOf("&");
          if (nextIndex >= 0) {
            s = s.substr(0, nextIndex);
          }
          url = url.replace(s, encodeURIComponent(title));
        } else {
          url += "&filename=" + encodeURIComponent(title);
        }
      } else {
        url += "?userid=" + encodeURIComponent(user.email) + "&filename=" + encodeURIComponent(title);
      }
      Util.copyStringToClipboard(url);
      let d = $("#modal-dialog");
      d.html("<div style='font-size: 90%;'>" + url + "<br>was copied to the clipboard. You can paste the link now.</div>").dialog({
        resizable: false,
        modal: true,
        title: "Share link",
        height: 200,
        width: 400,
        buttons: {
          'OK': () => d.dialog('close')
        }
      });
    } else {
      let d = $("#modal-dialog");
      d.html("<div style='font-size: 90%;'>Sorry, the link to this file cannot be created as you are not the owner.</div>").dialog({
        resizable: false,
        modal: true,
        title: "Sharing link not permitted",
        height: 200,
        width: 400,
        buttons: {
          'OK': () => d.dialog('close')
        }
      });
    }
  };
}

function setupShareExampleButton() {
  document.getElementById("main-page-share-example-button").onclick = () => {
    let url = document.location.href;
    let title = examples.getCurrentTitle();
    if (title) {
      let hasQuery = url.indexOf("?") > 0;
      if (hasQuery) {
        let index = url.indexOf("example=");
        if (index > 0) {
          let s = url.substring(index + 8);
          let nextIndex = s.indexOf("&");
          if (nextIndex >= 0) {
            s = s.substr(0, nextIndex);
          }
          url = url.replace(s, encodeURIComponent(title));
        } else {
          url += "&example=" + encodeURIComponent(title);
        }
      } else {
        url += "?example=" + encodeURIComponent(title);
      }
      Util.copyStringToClipboard(url);
      let d = $("#modal-dialog");
      d.html("<div style='font-size: 90%;'>" + url + "<br>was copied to the clipboard.</div>").dialog({
        resizable: false,
        modal: true,
        title: "Share Example Link",
        height: 200,
        width: 400,
        buttons: {
          'OK': () => d.dialog('close')
        }
      });
    } else {
      let d = $("#modal-dialog");
      d.html("<div style='font-size: 90%;'>No example is currently selected.</div>").dialog({
        resizable: false,
        modal: true,
        title: "Share Example Link",
        height: 200,
        width: 400,
        buttons: {
          'OK': () => d.dialog('close')
        }
      });
    }
  };
}

function setupHeader() {
  document.getElementById("main-page-sign-in-label").onclick = () => database.clickSignIn();
  document.getElementById("main-page-signout-button").onclick = () => database.signout();
  document.getElementById("main-page-name-label").innerHTML = Constants.Software.name;
  document.getElementById("main-page-tagline-label").innerHTML = Constants.Software.tagline;
  document.getElementById("main-page-new-file-button").onclick = () => flowchart.askToClear();
  document.getElementById("main-page-save-file-button").onclick = () => database.saveFileInCloud();
  document.getElementById("main-page-share-file-button").onclick = () => database.shareFileInCloud();
  document.getElementById("main-page-home-button").onclick = () => window.open("https://intofuture.org/iflow.html");
  document.getElementById("main-page-open-file-button").onclick = () => StateIO.open();
  document.getElementById("main-page-download-button").onclick = () => StateIO.saveAs(JSON.stringify(new State(Date.now(), user.email)));
  document.getElementById("main-page-settings-button").onclick = showUnderConstructionMessage;
  document.getElementById("main-page-help-button").onclick = showUnderConstructionMessage;
  document.getElementById("main-page-undo-button").onclick = () => {
    if (undoManager.hasUndo()) {
      undoManager.undo();
    }
  };
  document.getElementById("main-page-redo-button").onclick = () => {
    if (undoManager.hasRedo()) {
      undoManager.redo();
    }
  };
  document.getElementById("main-page-camera-button").onclick = () => {
    html2canvas(document.body).then(canvas => PngSaver.saveAs(canvas));
  };
  if (query.header === "no") document.getElementById("header").style.display = "none";
  setupTitleLabel();
  setupShareExampleButton();
}

window.onresize = () => {
  resize();
  draw();
};

function resize() {
  let onlyFlowTab = query.tab === "flow";
  let blockViewWrapper = document.getElementById("block-view-wrapper");
  let blockElementsPanelRect = document.getElementById("block-elements-panel").getBoundingClientRect() as DOMRect;
  let blockViewWrapperRect = blockViewWrapper.getBoundingClientRect() as DOMRect;
  let w = window.innerWidth - blockElementsPanelRect.right - 15;
  let h = window.innerHeight - blockViewWrapperRect.top - (onlyFlowTab ? 5 : 25);
  blockViewWrapper.style.width = w + "px";
  blockViewWrapper.style.height = h + "px";
  let elementsScroller = document.getElementById("elements-scroller") as HTMLDivElement;
  elementsScroller.style.height = h * 0.9 + "px";
  document.getElementById("block-playground").style.visibility = "visible";
  document.getElementById("example-dropdown-menu").style.visibility = "visible";
  document.getElementById("header-right").style.visibility = "visible";
  document.getElementById("footer").style.visibility = "visible";
}

function draw() {
  flowchart.blockView.requestDraw();
}
